const about = {
  portugues: {
    title: 'Sobre o Bella da Semana',
    subTitle: 'Tenha acesso a um ensaio completo e veja o que voce está perdendo.',
    boxText: `<span>
    O Bella da Semana é um portal que deixa você mais próximo do mundo das modelos através de fotografias e vídeos exclusivos, de alta qualidade e bom gosto. Você também encontrará colunas sobre temas como saúde, esportes, moda, relacionamentos e erotismo.
         <br><br>
        Oferecemos conteúdo exclusivo para assinantes com acesso a todos os ensaios, vídeos e wallpapers, além do privilégio de ver as fotos das novas modelos antes dos visitantes.
         <br><br>
        O portal também possui conteúdo aberto ao público em geral, sem a necessidade de assinatura ou registro de dados. O visitante pode ler as colunas e ver parte das fotos dos ensaios.
         <br><br>
        Desde janeiro de 2001, o Bella da Semana vem produzindo ensaios fotográficos de alto nível. São mais de 150 modelos em nosso portfólio, 15 mil fotos e muitos vídeos publicados em nosso site.</span>`,
    benefits: 'Promoções',
    subBenefits:
      'Ao se cadastrar, você fará parte de um clube exclusivo e terá benefícios que só o Bella pode oferecer:',
    listBenefits: [
      'Newsletters Bella da Semana',
      'Novos ensaios fotográficos atualizados constantemente',
      'Videos',
      'Wallpapers',
      'Promoções especiais e convites para eventos exclusivos'
    ],
    contactUs: 'Em caso de dúvida entre em',
    linkContactUs: 'fale conosco'
  },
  ingles: {
    title: 'About Bella Club',
    subTitle: "Get access to a full essay and see what you've been missing.",
    boxText: `<span>
        Bella Club brings you closer to the models’ universe through exclusive photos and high definition videos. You can also find columns by renowned writers who discuss subjects such as health, sports, fashion, relationships, and erotica.
        <br><br>
        Part of the content is open to the general audience, without the need to subscribe or register. We offer our members exclusive photos, and free pass to all video content.
        <br><br>
        Since January 2001, Bella Club produces top-level photo shootings. There are over 150 models in our library and over 15 thousand photos published in our website.</span>`,
    benefits: 'Promotions',
    subBenefits:
      'By registering you become part of an exclusive club and are able to enjoy benefits that only Bella Club can bring you:',
    listBenefits: [
      'Bella Club Newsletter',
      'New photo shoots constantly updated',
      'Videos',
      'Wallpapers',
      'Special offers'
    ],
    contactUs: 'In case of any doubts, please do ',
    linkContactUs: 'contact us'
  }
}

export default about
